"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable @typescript-eslint/no-unused-vars */
var react_1 = __importDefault(require("react"));
var react_admin_1 = require("react-admin");
var EventManagement_module_css_1 = __importDefault(require("./EventManagement.module.css"));
var parseCustomDateString = function (dateString) {
    var dateStr = dateString.toString();
    var year = parseInt(dateStr.substring(0, 4), 10);
    var month = parseInt(dateStr.substring(4, 6), 10) - 1;
    var day = parseInt(dateStr.substring(6, 8), 10);
    var hour = parseInt(dateStr.substring(8, 10), 10);
    var minute = parseInt(dateStr.substring(10, 12), 10);
    return new Date(year, month, day, hour, minute);
};
var CustomDateField = function (_a) {
    var source = _a.source, label = _a.label, type = _a.type;
    var record = (0, react_admin_1.useRecordContext)();
    if (!record)
        return null;
    var date = record[source];
    if (!date)
        return null;
    var parsedDate = parseCustomDateString(date);
    var formattedDate = parsedDate.toLocaleDateString("en-GB");
    var formattedTime = parsedDate.toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" });
    var colorClass = "";
    if (type === "end" && record.start) {
        var endDateTime = parsedDate.getTime();
        var currentDateTime = new Date().getTime();
        var startDateTime = parseCustomDateString(record.start).getTime();
        if (currentDateTime < startDateTime) {
            colorClass = EventManagement_module_css_1.default["before-interval"];
        }
        else if (currentDateTime >= startDateTime && currentDateTime <= endDateTime) {
            colorClass = EventManagement_module_css_1.default["in-interval"];
        }
        else {
            colorClass = EventManagement_module_css_1.default["after-interval"];
        }
    }
    return (react_1.default.createElement("div", { className: "".concat(EventManagement_module_css_1.default["date-field-container"], " ns-font-family") },
        react_1.default.createElement("span", { className: type === "end" ? colorClass : "" }, formattedDate),
        react_1.default.createElement("span", { className: type === "end" ? colorClass : "" }, formattedTime)));
};
exports.default = CustomDateField;
